import { render, staticRenderFns } from "./DisputeLettersFilter.vue?vue&type=template&id=5d315d48&"
import script from "./DisputeLettersFilter.vue?vue&type=script&lang=js&"
export * from "./DisputeLettersFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports